import { getLangName } from './getLangName';

export interface ILangItem {
  code: string;
  name: string;
}

// https://xiaomi.feishu.cn/sheets/shtcnBCcF9yi6NuuteXtI3hhXIg?new_source=message#2aIgyu
// app地区映射, 默认省略en(通用英语)，使用时会自动添加上
const langMap: any = {
  CN: { name: '中国', lang: ['zh_cn','tc_cn','en_cn','bo_cn','ug_cn'] },
  IN: { name: '印度', lang: ['en_in'] },
  HK: { name: '香港', lang: ['zh_hk'] },
  TW: { name: '台湾', lang: ['zh_tw'] },
  JP: { name: '日本', lang: ['ja'] },
  KR: { name: '韩国', lang: ['ko', 'en_kr', 'en'] },
  UA: { name: '乌克兰', lang: ['uk'] },
  PL: { name: '波兰', lang: ['pl'] },
  HR: { name: '克罗地亚', lang: ['hr'] },
  CZ: { name: '捷克', lang: ['cs'] },
  GR: { name: '希腊', lang: ['el'] },
  BG: { name: '保加利亚', lang: ['bg'] },
  SK: { name: '斯洛伐克', lang: ['sk'] },
  SI: { name: '斯洛文尼亚', lang: ['sl'] },
  HU: { name: '匈牙利', lang: ['hu'] },
  AT: { name: '奥地利', lang: ['de'] },
  NO: { name: '挪威', lang: ['nb_no'] },
  DK: { name: '丹麦', lang: ['da'] },
  SE: { name: '瑞典', lang: ['sv'] },
  FI: { name: '芬兰', lang: ['fi'] },
  LT: { name: '立陶宛', lang: ['lt'] },
  CY: { name: '塞浦路斯', lang: ['el','tr'] },
  EE: { name: '爱沙尼亚', lang: ['et', 'et_ee'] },
  LV: { name: '拉脱维亚', lang: ['lv'] },
  RU: { name: '俄罗斯', lang: ['ru'] },
  BY: { name: '白俄罗斯', lang: ['be'] },
  ES: { name: '西班牙', lang: ['es_es', 'es', 'en'] },
  PT: { name: '葡萄牙', lang: ['pt'] },
  NL: { name: '荷兰', lang: ['nl'] },
  FR: { name: '法国', lang: ['fr'] },
  IT: { name: '意大利', lang: ['it'] },
  GB: { name: '英国', lang: ['en_gb'] },
  CH: { name: '瑞士', lang: ['fr', 'de', 'it'] },
  DE: { name: '德国', lang: ['de'] },
  IE: { name: '爱尔兰', lang: [] },
  BE: { name: '比利时', lang: ['nl', 'fr', 'de'] },
  LU: { name: '卢森堡', lang: ['fr', 'de'] },
  MT: { name: '马耳他', lang: [] },
  MX: { name: '墨西哥', lang: ['es_la'] },
  CL: { name: '智利', lang: ['es_la'] },
  PE: { name: '秘鲁', lang: ['es_la'] },
  BR: { name: '巴西', lang: ['pt_br'] },
  TH: { name: '泰国', lang: ['th', 'en'] },
  SG: { name: '新加坡', lang: ['en_sg'] },
  MY: { name: '马来西亚', lang: ['ms'] },
  VN: { name: '越南', lang: ['vi'] },
  MM: { name: '缅甸', lang: ['my'] },
  PH: { name: '菲律宾', lang: [] },
  ID: { name: '印度尼西亚', lang: ['id'] },
  PK: { name: '巴基斯坦', lang: [] },
  NZ: { name: '新西兰', lang: [] },
  AU: { name: '澳大利亚', lang: [] },
  KE: { name: '肯尼亚', lang: [] },
  EG: { name: '埃及', lang: ['ar'] },
  NG: { name: '尼日利亚', lang: [] },
  MA: { name: '摩洛哥', lang: ['ar'] },
  TR: { name: '土耳其', lang: ['tr'] },
  IL: { name: '以色列', lang: ['he', 'ar'] },
  QA: { name: '卡塔尔', lang: ['ar'] },
  OM: { name: '阿曼', lang: ['ar'] },
  SA: { name: '沙特阿拉伯', lang: ['ar'] },
  IQ: { name: '伊拉克', lang: ['ar'] },
  AE: { name: '阿联酋', lang: ['ar'] },
  JO: {name: '约旦', lang: ['ar'] },
  RO: { name: '罗马尼亚', lang: ['ro', 'en'] },
  US: { name: '美国', lang: ['es_la','en_us'] },
  LA: { name: '老挝', lang: [ 'la'] },
  KH: { name: '柬埔寨', lang: [ 'km_kh'] },
  CO: { name: '哥伦比亚', lang: [ 'es_la'] },
  CR: { name: '哥斯达黎加', lang: [ 'es_la'] },
  SV: { name: '萨尔瓦多', lang: [ 'es_la'] },
  PA: { name: '巴拿马', lang: [ 'es_la'] },
  AR: { name: '阿根廷', lang: [ 'es_la'] },
  IS: { name: '冰岛', lang: [ 'is_is'] },
  LI: { name: '列支敦士登', lang: [ 'de'] },
  KZ: { name: '哈萨克斯坦', lang: [ 'kk_kz','ru'] },
  UY: { name: '乌拉圭', lang: [ 'es_la'] },
  EC: { name: '厄瓜多尔', lang: [ 'es_la'] },

  BD: { name: '孟加拉', lang: ['bn_bd'] },
  BN: { name: '文莱', lang: [] },
  CA: { name: '加拿大', lang: [] },
  MK: { name: '马其顿', lang: [] },
  UG: { name: '乌干达', lang: [] },
  ZM: { name: '赞比亚', lang: [] },
  GH: { name: '加纳', lang: [] },
  BW: { name: '博茨瓦纳', lang: [] },
  PG: { name: '巴布亚新几内亚', lang: [] },
  DO: { name: '多米尼克', lang: [] },
  TZ: { name: '坦桑尼亚', lang: [] },
  CI: { name: '科特迪瓦', lang: [ 'fr_fr'] },
  KW: { name: '科威特', lang: [ 'ar_sa'] },
  LB: { name: '黎巴嫩', lang: [ 'ar_sa'] },
  BH: { name: '巴林', lang: [ 'ar_sa'] },
  TN: { name: '突尼斯', lang: [ 'ar_sa'] },
  SO: { name: '索马里', lang: [ 'ar_sa'] },
  LY: { name: '利比亚', lang: [ 'ar_sa'] },
  DZ: { name: '阿尔及利亚', lang: [ 'ar_sa'] },
  KG: { name: '吉尔吉斯斯坦', lang: [ 'ru_ru'] },
  TJ: { name: '塔吉克斯坦', lang: [ 'ru_ru'] },
  VE: { name: '委内瑞拉', lang: [ 'es_la'] },
  GT: { name: '危地马拉', lang: [ 'es_la'] },
  AO: { name: '安哥拉', lang: [ 'pt_pt'] },
  MZ: { name: '莫桑比克', lang: [ 'pt_pt'] },
  MD: { name: '摩尔多瓦', lang: [ 'ro'] },
  MO: { name: '澳门', lang: [ 'zh_hk'] },
  NP: { name: '尼泊尔', lang: [ 'ne_np'] },
  RI: { name: '塞尔维亚', lang: [ 'sr_rs'] },
  RS: { name: '塞尔维亚', lang: [ 'sr'] },
  BK: { name: '波黑', lang: [ 'sr_rs'] },
  MJ: { name: '黑山', lang: [ 'sr_rs'] },
  LK: { name: '斯里兰卡', lang: [ 'ta_in'] },
  UZ: { name: '乌兹别克斯坦', lang: [ 'uz'] },
  AL: { name: '阿尔巴尼亚', lang: [ 'sq_al'] },
  AZ: { name: '阿塞拜疆', lang: [ 'az_az'] }
};

export const getLang = (region: string): { code: string; name: string }[] => {
  const fallback = [{ code: 'en', name: getLangName('en').nativeName }];
  if (!region) {
    return fallback;
  }
  region = region.toUpperCase();
  if (!langMap[region]) {
    return fallback;
  }
  let lang = [...langMap[region].lang];

  // 如果列表中没有英语，则都默认添加英语
  if(!lang.includes("en")){
    lang.push("en")
  }
  lang = lang.map(code => ({
    code: code,
    name: getLangName(code)?.nativeName
  }));
  return lang;
};

export const getAllLang = (): { code: string; name: string }[] => {
  let lang: string[] = [];
  for (const key in langMap) {
    if (Object.prototype.hasOwnProperty.call(langMap, key)) {
      lang = lang.concat(langMap[key].lang);
    }
  }
  lang.push('en');
  lang = Array.from(new Set(lang));
  let res = lang.map(code => ({
    code: code,
    name: getLangName(code)?.nativeName
  }));
  res.sort((a, b) => b.name?.localeCompare(a.name));
  return res;
};

export const getTargetLang = (region: string): string[] => {
  region = region.toUpperCase();
  const lang = langMap[region]?.lang || [];
  lang.push('en');
  return lang;
};
